import axios from 'axios'

export const getLocaleMessages = async (locale: string): Promise<any> => {
	return await axios.get('locale.php', {params: {locale: locale}})
}
